import { isOverseasVersion } from 'common-module/src/util';

export const DISABLED_PERMISSION = '__disabled__';
const PROJECT_SUPER_ADMIN = '0';
export type RightVersion = 'free' | 'trial' |'standard' | 'professional' | 'private';
export type PermissionMeta = {
  // 权限列表，权限名称，例如：'sys:menu:orginfo'
  permissions?: string[];
  // 用户a/b开关
  userSwitch?: string[];
  // 项目开关
  projectSwitch?: string[];
  // 角色列表，角色名称，例如：'admin'
  roles?: string[];
  // 角色列表是and关系还是or关系
  roleAnd?: boolean;
  // 版本限制，例如：['trial','standard', 'professional', 'private']
  rightVersion?: RightVersion[];
  // 后备权限，当当前权限判断失败时，会尝试使用后备权限，fallback 数组中的权限会按顺序尝试，直到找到第一个合适的权限为止。
  fallback?: PermissionMeta[];
  // 兼容老逻辑，只有在router.beforeEach中使用，当权限判断成功时，会调用该函数，里面都是store的getters
  notAccessFunctions?: string[];
}
export const integrationWechat: PermissionMeta = {
                   
           permissions: [DISABLED_PERMISSION]
          
                                         
           
};
export const integrationDingTalk: PermissionMeta = {
                   
           userSwitch: ['dingtalk_switch'],
           
  permissions: ['integration:dingTalk']
};

export const integrationSlack: PermissionMeta = {
                   
                                             
          
  permissions: ['integration:slack']
           
};

export const integrationTeams: PermissionMeta = {
                   
                                             
          
  permissions: ['integration:teams']
           
};
export const integrationFeiShu: PermissionMeta = {
                   
           userSwitch: ['lark_switch'],
           
  permissions: ['integration:feiShu']
};
export const integrationZoom: PermissionMeta = {
                   
                                             
          
  permissions: ['integration:zoom'],
  userSwitch: ['zoom_meeting_switch']
           
};
export const integrationGitLab: PermissionMeta = {
  permissions: ['integration:gitLab']
};
export const integrationFoxLab: PermissionMeta = {
                   
           permissions: [DISABLED_PERMISSION]
          
                                     
           
};
export const integrationGitHub: PermissionMeta = {
  permissions: ['integration:gitHub']
};
export const integrationCoding: PermissionMeta = {
                   
           permissions: [DISABLED_PERMISSION]
          
                                     
           
};
export const integrationCodeUp: PermissionMeta = {
                   
           permissions: [DISABLED_PERMISSION]
          
                                     
           
};
export const integrationJenkins: PermissionMeta = {
  permissions: ['integration:jenkins']
};
export const integrationSentry: PermissionMeta = {
  permissions: ['integration:sentry'],
  userSwitch: ['sentry_switch']
};
export const integrationZapier: PermissionMeta = {
                   
                                             
          
  permissions: ['integration:zapier']
           
};
export const integrationLdap: PermissionMeta = {
                 
                                             
          
  permissions: ['integration:ldap']
           
};
export const integrationSamlAzureAD: PermissionMeta = {
                 
                                             
          
  permissions: ['integration:samlAzureAD']
           
};
export const integrationFigma: PermissionMeta = {
  permissions: ['integration:figma']
};
export const integrationNotion: PermissionMeta = {
                   
                                             
          
  permissions: ['integration:notion'],
  userSwitch: ['notion_switch']
           
};
export const integrationReleaseCard: PermissionMeta = {
  permissions: ['version:config']
};
export const integrationRelease: PermissionMeta = {
  userSwitch: ['function_version_switch'],
  permissions: ['version:config']
};
export const integrationReleaseView: PermissionMeta = {
  userSwitch: ['function_version_switch'],
  permissions: ['version:config', 'version:show'],
  fallback: [integrationRelease]
};
export const integrationCodingTime: PermissionMeta = {
  permissions: ['integration:codingTime:config'],
  rightVersion: ['trial', 'standard', 'professional', 'private']
};
export const integration: PermissionMeta = {
  // 让当前权限判断失败，并尝试使用后备权限，fallback 数组中的权限会按顺序尝试，直到找到第一个合适的权限为止。
  permissions: [DISABLED_PERMISSION],
  fallback: [
    integrationWechat, integrationDingTalk, integrationSlack, integrationFeiShu, integrationZoom,
    integrationGitLab, integrationFoxLab, integrationGitHub, integrationCoding,
    integrationCodeUp, integrationJenkins, integrationSentry, integrationZapier,
    integrationLdap, integrationFigma, integrationNotion, integrationReleaseCard, integrationCodingTime
  ]
};

export const systemFieldMgr: PermissionMeta = {
  permissions: ['setting:mgrField']
};
export const customAlias: PermissionMeta = {
  permissions: ['setting:customAlias']
};
export const mgrApi: PermissionMeta = {
  permissions: ['setting:mgrApi']
};
export const systemSetting: PermissionMeta = {
  permissions: [DISABLED_PERMISSION],
  fallback: [systemFieldMgr, customAlias, mgrApi]
};
export const systemImport: PermissionMeta = {
  permissions: ['integration:jira']
};
export const dissolutionOrg: PermissionMeta = {
  permissions: ['sys:dissolution_org']
};
export const orgInfo: PermissionMeta = {
  permissions: ['sys:setting:menu:orginfo'],
  fallback: [dissolutionOrg]
};

export const upgrade: PermissionMeta = {
  permissions: ['sys:setting:subscription:buy']
};
export const settingSubscription: PermissionMeta = {
  permissions: ['sys:setting:subscription'],
  fallback: [upgrade]
};
export const settingBilling: PermissionMeta = {
  permissions: ['sys:setting:menu:order']
};
export const settingAuditLog: PermissionMeta = {
  permissions: ['sys:setting:audit']
};
export const settingAiTokenReport: PermissionMeta = {
  permissions: ['sys:setting:ai_token_report']
};
export const recycleBin: PermissionMeta = {
  rightVersion: ['standard', 'professional', 'private']
};
export const settingMemberEdit: PermissionMeta = {
  permissions: ['sys:setting:member_manager:user:edit']
};
export const settingMemberView: PermissionMeta = {
  permissions: ['sys:setting:member_manager:user:edit'],
  fallback: [settingMemberEdit]
};
export const settingMemberGroupEdit: PermissionMeta = {
  permissions: ['sys:setting:member_manager:group:edit']
};
export const settingMemberGroupView: PermissionMeta = {
  permissions: ['sys:setting:member_manager:group:edit'],
  fallback: [settingMemberGroupEdit]
};
export const settingMember: PermissionMeta = {
  permissions: [DISABLED_PERMISSION],
  fallback: [settingMemberView, settingMemberEdit]
};
export const settingMemberGroup: PermissionMeta = {
  permissions: [DISABLED_PERMISSION],
  fallback: [settingMemberGroupView, settingMemberGroupEdit]
};
export const settingMemberAll: PermissionMeta = {
  permissions: [DISABLED_PERMISSION],
  fallback: [settingMember, settingMemberGroup]
};
const settingPermissions: PermissionMeta['permissions'] = ['sys:setting:role_permissions'];
export const settingPermissionAB: PermissionMeta = {
  permissions: settingPermissions,
  userSwitch: ['user:system_permission_switch']
};
export const settingPermission: PermissionMeta = {
  permissions: settingPermissions,
  rightVersion: ['private', 'professional'],
  fallback: [settingPermissionAB]
};
export const settingPermissionReadonly: PermissionMeta = {
  permissions: settingPermissions,
  rightVersion: [ 'free', 'trial', 'standard' ]
};
export const settingPermissionReadonlyOrMgr: PermissionMeta = {
  permissions: [DISABLED_PERMISSION],
  fallback: [settingPermissionReadonly, settingPermission]
};
export const settingWorkingDay: PermissionMeta = {
  permissions: ['sys:setting:menu:workday']
};
export const settingRecorder: PermissionMeta = {
  userSwitch: ['user:recorder_switch']
};
export const labConfig: PermissionMeta = {
  roles: ['organizationOwner', 'organizationAdmin']
};
export const settingLab: PermissionMeta = {
  permissions: ['sys:setting:lab'],
  fallback: [labConfig]
};
export const settingOrganizationalMgr: PermissionMeta = {
  permissions: [DISABLED_PERMISSION],
  fallback: [orgInfo, settingMemberAll, settingPermission, settingSubscription, settingBilling]
};

export const inviteMember: PermissionMeta = {
  permissions: ['sys:admin', 'project_perm:admin']
};
export const projectOverviewOrgField: PermissionMeta = {
  permissions: ['-1', 'sys:admin']
};
export const insightsPage: PermissionMeta = {
  permissions: ['efficiency:view'],
  rightVersion: isOverseasVersion ? [] : ['standard', 'professional', 'private']
};
export const teamPage: PermissionMeta = {
  permissions: ['sys:menu:team']
};
export const roadmapPage: PermissionMeta = {
  permissions: ['sys:menu:roadmap']
};
export const documentPage: PermissionMeta = {
                   
                             
           
  permissions: ['sys:menu:doc']
};

export const backlogPage: PermissionMeta = {
  projectSwitch: ['module_sprint_switch'],
  notAccessFunctions: ['user/isProjectInnerCollaboratorButNotAdmin']
};
export const epicPage: PermissionMeta = {
  projectSwitch: ['module_epic_switch'],
  notAccessFunctions: ['user/isProjectInnerCollaboratorButNotAdmin']
};
export const ganttPage: PermissionMeta = {
  projectSwitch: ['module_epic_switch'],
  userSwitch: ['user:gantt_switch'],
  notAccessFunctions: ['user/isProjectInnerCollaboratorButNotAdmin']
};
export const cicdPage: PermissionMeta = {
  projectSwitch: ['jenkins_integration_switch', 'foxLab_cicd_integration_switch', 'gitLab_cicd_integration_switch'],
  notAccessFunctions: ['user/isProjectInnerCollaboratorButNotAdmin']
};
export const projectOverviewEdit: PermissionMeta = {
  permissions: [PROJECT_SUPER_ADMIN, 'project_perm:overview']
};
export const projectOverview: PermissionMeta = {
  notAccessFunctions: ['user/isProjectInnerCollaboratorButNotAdmin'],
  fallback: [projectOverviewEdit]
};
export const projectOverviewEditField: PermissionMeta = {
  // eslint-disable-next-line spellcheck/spell-checker
  permissions: [PROJECT_SUPER_ADMIN, 'project_perm:overview:editfield']
};
export const projectOverviewAddField: PermissionMeta = {
  // eslint-disable-next-line spellcheck/spell-checker
  permissions: [PROJECT_SUPER_ADMIN, 'project:overview:addfield']
};
export const automationPage: PermissionMeta = {
  permissions: [PROJECT_SUPER_ADMIN, 'project_perm:setting:automation']
};
export const projectMemberPage: PermissionMeta = {
  permissions: [PROJECT_SUPER_ADMIN, 'project_perm:setting:member']
};
export const projectIssueTypePage: PermissionMeta = {
  permissions: [PROJECT_SUPER_ADMIN, 'project_perm:setting:issuetype']
};
export const projectWorkflowPage: PermissionMeta = {
  permissions: [PROJECT_SUPER_ADMIN, 'project_perm:setting:workflow']
};
export const projectFeaturesPage: PermissionMeta = {
  permissions: [PROJECT_SUPER_ADMIN, 'project_perm:setting:features']
};
export const projectIssueVisibilityPage: PermissionMeta = {
  roles: ['organizationOwner', 'organizationAdmin', 'projectOwner', 'projectAdmin']
};
export const projectWebhookPage: PermissionMeta = {
  permissions: [PROJECT_SUPER_ADMIN, 'project_perm:setting:webhook']
};

export const projectLogsPage: PermissionMeta = {
  // eslint-disable-next-line spellcheck/spell-checker
  permissions: [PROJECT_SUPER_ADMIN, 'project_perm:setting:auditlogs']
};
export const projectTagsPage: PermissionMeta = {
  permissions: [PROJECT_SUPER_ADMIN, 'project_perm:setting:tag']
};
export const projectMemberGroupPage: PermissionMeta = {
  permissions: [PROJECT_SUPER_ADMIN, 'project_perm:setting:member_groups']
};
const projectPermissions: PermissionMeta['permissions'] = [PROJECT_SUPER_ADMIN, 'project_perm:setting:role_permissions'];
export const projectPermissionAB: PermissionMeta = {
  permissions: projectPermissions,
  userSwitch: ['user:system_permission_switch']
};
export const projectPermission: PermissionMeta = {
  permissions: projectPermissions,
  rightVersion: ['private', 'professional'],
  fallback: [projectPermissionAB]
};
export const projectSetting: PermissionMeta = {
  permissions: [DISABLED_PERMISSION],
  fallback: [
    automationPage, projectMemberPage, projectIssueTypePage, projectWorkflowPage,
    projectFeaturesPage, projectIssueVisibilityPage, projectWebhookPage, projectLogsPage, projectTagsPage, projectPermission, projectMemberGroupPage
  ]
};

export const projectCreate: PermissionMeta = {
  permissions: [PROJECT_SUPER_ADMIN, 'project:create']
};
export const projectArchive: PermissionMeta = {
  permissions: [PROJECT_SUPER_ADMIN, 'project:archive']
};
export const projectTemplateMgr: PermissionMeta = {
  permissions: [PROJECT_SUPER_ADMIN, 'project:mgrTemplate']
};
export const issueDelete: PermissionMeta = {
  permissions: [PROJECT_SUPER_ADMIN, 'project_perm:issue:del']
};
export const issueLayoutEdit: PermissionMeta = {
  permissions: [PROJECT_SUPER_ADMIN, 'project_perm:issue:layout']
};
export const sprintCreate: PermissionMeta = {
  permissions: [PROJECT_SUPER_ADMIN, 'project_perm:sprint:create']
};
export const sprintUpdate: PermissionMeta = {
  permissions: [PROJECT_SUPER_ADMIN, 'project_perm:sprint:update']
};
export const sprintDelete: PermissionMeta = {
  permissions: [PROJECT_SUPER_ADMIN, 'project_perm:sprint:del']
};
export const sprintClose: PermissionMeta = sprintUpdate;
export const sprintShare: PermissionMeta = {
  permissions: [PROJECT_SUPER_ADMIN, 'project_perm:sprint-kanban:share'],
  userSwitch: ['user:kanban-share-switch']
};
export const issueDataUpload: PermissionMeta = {
  permissions: [PROJECT_SUPER_ADMIN, 'project_perm:airtable:load:upload']
};
export const issueDataDownload: PermissionMeta = {
  permissions: [PROJECT_SUPER_ADMIN, 'project_perm:airtable:load:download']
};
export const issueImportPage: PermissionMeta = {
  ...issueDataUpload,
  notAccessFunctions: ['user/isProjectInnerCollaboratorButNotAdmin']
};
export const commentImportPage: PermissionMeta = {
  ...issueDataUpload,
  notAccessFunctions: ['user/isProjectInnerCollaboratorButNotAdmin']
};

export const supportCenterPage: PermissionMeta = {
  permissions: ['sys:menu:support-center']
};
export const supportCenterTicketsPage: PermissionMeta = {
  permissions: ['sys:menu:support-center:tickets']
};
export const supportCenterRequestersPage: PermissionMeta = {
  permissions: ['sys:menu:support-center:requesters']
};
export const supportCenterEmailConfigPage: PermissionMeta = {
  permissions: ['sys:menu:support-center:email-config']
};

export const executeForSome = (config: {
  meta: PermissionMeta,
  handler: () => void
}[], checkAccessPermission: (meta: PermissionMeta) => boolean) => {
  const item = config.find((item) => checkAccessPermission(item.meta));
  item?.handler();
};
